import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Col, Grid, Row} from 'react-bootstrap';
import BackLink from '../../../common/back-link';
import Button from '../../../common/button';
import {getAppSettings, saveAppVersion, generateApiKey} from '../../../../actions/app';
import AppSettingsTable from './app-settings-table';
import AppVersion from './app-version';

class AppSettings extends Component {
  generateApiKey = () => {
    const {dispatch} = this.props;
    dispatch(generateApiKey());
  };

  onVersionSave = (payLoad) => {
    const {dispatch} = this.props;
    dispatch(saveAppVersion(payLoad));
  };

  componentDidMount() {
    const {dispatch} = this.props;
    dispatch(getAppSettings());
  }

  render() {
    const {
      loading, apiKey, appVersion
    } = this.props;

    return (
      <Grid>
        <Row>
          <Col lg={12}>
            <BackLink href="/"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <h2 className="text-uppercase">
              App settings
              <div className="pull-right">
                <Button onClick={this.generateApiKey}>Generate new api key</Button>
              </div>
            </h2>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <AppSettingsTable apiKey={apiKey} loading={loading}/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <h2 className="text-uppercase">
              App versions
            </h2>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <AppVersion version={appVersion} onSave={this.onVersionSave}/>
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  ...state.appSettings,
  loading: !state.appSettings.fetched && state.appSettings.fetching,
});

export default connect(mapStateToProps)(AppSettings);



// WEBPACK FOOTER //
// ./src/components/admin/app/app-settings/app-settings.jsx